import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { router } from '../../instances'

const RouterExposer = () => {
  const location = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    router.setNavigate(navigate)
  }, [])

  useEffect(() => {
    router.setLocation(location)
  }, [location])

  return null
}

export default RouterExposer
